import { render, staticRenderFns } from "./FriendshipLink.vue?vue&type=template&id=4137fde1&scoped=true&"
import script from "./FriendshipLink.vue?vue&type=script&lang=js&"
export * from "./FriendshipLink.vue?vue&type=script&lang=js&"
import style0 from "./FriendshipLink.vue?vue&type=style&index=0&id=4137fde1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4137fde1",
  null
  
)

export default component.exports